/**
 * Altura da faixa global (GEN-3497).
 *
 * O número aparece em vários lugares (a própria barra, o container do Kanban 2.0, as
 * colunas do Kanban legado, popovers com `max-h` calculado). Em vez de espalhar "56px"
 * pelo código, quem precisa descontar a barra usa a variável CSS — assim mudar a altura
 * é um lugar só, e nada fica para trás criando barra de rolagem dupla.
 */
export const TOPNAV_HEIGHT_PX = 48;
export const TOPNAV_HEIGHT = `${TOPNAV_HEIGHT_PX}px`;

/** Nome da variável CSS publicada em :root (ver styles/theme.ts). */
export const TOPNAV_HEIGHT_CSS_VAR = "--taxly-topnav-h";

/**
 * Altura útil abaixo da barra. Usar em vez de `100vh` em qualquer container que ocupe
 * a tela inteira dentro da área autenticada.
 */
export const CONTENT_HEIGHT = `calc(100vh - var(${TOPNAV_HEIGHT_CSS_VAR}, ${TOPNAV_HEIGHT}))`;

/**
 * Para onde vai o sino com "+" (Alertas personalizados) da barra — GEN-4080.
 *
 * Os alertas viraram um TIPO de automação: a página deles é a lista de Automações filtrada na aba
 * Alertas. Antes o atalho abria Configurações → Notificações → "Alertas personalizados", com uma
 * tabela própria e um assistente próprio — dois lugares para a mesma coisa.
 */
export const AUTOMATIONS_PATH = "/automacoes?tipo=alertas";

/**
 * Aparência dos botões de ícone da barra (busca, raio, sino com "+", sino, ajuda).
 *
 * Moravam repetidas em TopNav, AutomacoesNaBarra e AlertsBell — e qualquer ajuste num deles deixava
 * a barra com dois tons de cinza. O hover precisa de contraste REAL: a faixa vive sobre #F8FAFC, e o
 * cinza #F2F0F4 fica a 2% dele — o retorno existia e ninguém enxergava.
 */
export const TOPNAV_ICON_BUTTON_PROPS = {
  variant: "ghost",
  size: "sm",
  h: "30px",
  minW: "30px",
  w: "30px",
  color: "#77777B",
  borderRadius: "6px",
  sx: {
    transition: "background-color 150ms ease, color 150ms ease",
    "&:hover": { backgroundColor: "#E2E8F0", color: "#303033" },
    "&:active": { backgroundColor: "#D6D4D8" },
  },
} as const;
